<script setup>
import {defineProps, defineEmits} from "vue";
import HeaderDeAprovarContasAPagar from "./HeaderDeAprovarContasAPagar.vue";
import LinhaDeAprovarContasAPagar from "./LinhaDeAprovarContasAPagar.vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
]);

const emits = defineEmits([
    "update:alteraContasAPagar",
    "update:alteraContaAPagar"
]);

//==================================================================//
//==================== Altera Contas a Pagar =======================//
//==================================================================//

const alteraContasAPagar = (update)=>{

    emits('update:alteraContasAPagar',update);

};

//==================================================================//
//=================== Altera Conta a Pagar =========================//
//==================================================================//

const alteraContaAPagar = (update)=>{

    emits('update:alteraContaAPagar',update);

};

</script>

<template>

    <v-card class="c-card">

        <v-card-title class="c-card__title">

            <h3 class="c-title">

                {{props?.dado?.tipo}} {{props?.dado?.codigo}}
                
            </h3>

        </v-card-title>

        <div class="c-table-wrapper">

            <div class="c-table">

                <HeaderDeAprovarContasAPagar
                    :controlesDesativados="props?.controlesDesativados"
                    :dado="props?.dado"
                    @update:alteraContasAPagar="alteraContasAPagar"
                ></HeaderDeAprovarContasAPagar>
                
                <div class="c-table__body">

                    <LinhaDeAprovarContasAPagar v-for="contaAPagar in props?.dado?.contasAPagar"
                        :key="contaAPagar.id"
                        :controlesDesativados="props?.controlesDesativados"
                        :dado="props?.dado"
                        :contaAPagar="contaAPagar"
                        @update:alteraContaAPagar="alteraContaAPagar"
                    ></LinhaDeAprovarContasAPagar>

                </div>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-parcelas{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-parcelas__titulo {
    grid-area: titulo;
}

.c-table-wrapper{
    overflow: hidden !important;
    width: calc(100vw - 24px);
    padding: 12px !important;
}

.c-table{
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

.c-table__body{
    display: contents;
}

</style>